import * as React from 'react';
import HelpIcon from '@patternfly/react-icons/dist/esm/icons/help-icon';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { Button, Tooltip, Popover } from '@patternfly/react-core';
import { TableText } from './TableText';
export var HeaderCellInfoWrapper = function HeaderCellInfoWrapper(_ref) {
  var children = _ref.children,
      info = _ref.info,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'tooltip' : _ref$variant,
      popoverProps = _ref.popoverProps,
      tooltipProps = _ref.tooltipProps,
      ariaLabel = _ref.ariaLabel;
  return React.createElement("div", {
    className: css(styles.tableColumnHelp, className)
  }, typeof children === 'string' ? React.createElement(TableText, null, children) : children, React.createElement("span", {
    className: css(styles.tableColumnHelpAction)
  }, variant === 'tooltip' ? React.createElement(Tooltip, Object.assign({
    content: info
  }, tooltipProps), React.createElement(Button, {
    variant: "plain",
    "aria-label": ariaLabel || typeof info === 'string' && info || 'More info'
  }, React.createElement(HelpIcon, {
    noVerticalAlign: true
  }))) : React.createElement(Popover, Object.assign({
    bodyContent: info
  }, popoverProps), React.createElement(Button, {
    variant: "plain",
    "aria-label": ariaLabel || typeof info === 'string' && info || 'More info'
  }, React.createElement(HelpIcon, {
    noVerticalAlign: true
  })))));
};
HeaderCellInfoWrapper.displayName = 'HeaderCellInfoWrapper';